import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Container, LinearProgress, Link as MuiLink, Stack, Typography, } from "@mui/material";
import { useIsFetching } from "@tanstack/react-query";
import { Link } from "react-router";
export const AppHeader = ({ logo, title, to, children, }) => {
    const isFetching = useIsFetching();
    return (_jsxs(_Fragment, { children: [_jsx(LinearProgress, { value: 100, variant: isFetching ? "indeterminate" : "determinate", sx: {
                    position: "sticky",
                    top: 0,
                    zIndex: 100,
                    "> span": { background: ({ palette }) => palette.primary.main },
                } }), _jsx(Container, { component: "header", sx: { maxWidth: "100% !important" }, children: _jsxs(Stack, { spacing: 1, useFlexGap: true, direction: "row", sx: {
                        margin: "0 auto",
                        maxWidth: (theme) => theme.Navbar.maxWidth,
                        alignItems: "center",
                        minHeight: 48,
                    }, children: [_jsxs(MuiLink, { component: Link, to: to, sx: {
                                mr: "auto",
                                svg: { mr: 1 },
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                            }, children: [logo, _jsx(Typography, { component: "h1", variant: "h4", children: title })] }), children] }) })] }));
};
//# sourceMappingURL=AppHeader.js.map